/**
 * ModelosPage component
 * @returns <ModelosPage />
 */
import TitleAndButton from "../components/TitleAndButton";
import Breadcrumbs from "../components/Breadcrumbs";
import StoreGridContainer from "../components/StoreGridContainer";
import FilterContainer from "../components/FilterContainer";
import FiltersContainer from "../components/FiltersContainer";
import BoxWithBackgroundContainer from "../components/BoxWithBackgroundContainer";
import InputRadio from "../components/InputRadio";
import InputCheckBox from "../components/InputCheckBox";
import Drawer from "../components/Drawer";
import Button from "../components/Button";
import Accordion from "../components/Accordion";
import LegalFooter from "../components/LegalFooter";
import { useSearchParams } from "react-router-dom";
import {
    uniqueModels,
    uniqueVersions,
    uniqueColors,
    uniqueTypes,
    uniqueVersionsIds,
} from "../scripts/helpers/uniqueReducers";
import { lightColor } from "../scripts/helpers/lightColor";
import Loader from "../components/Loader";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import {
    useGetAllModelsQuery,
    useGetAllAccesoriesQuery,
    useGetAllMaintenancePlansQuery,
    useGetLegalesQuery,
} from "../redux/apiSlice";

const ModelosPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const segmentParam = searchParams.get("segment");
    const serieParam = searchParams.get("serie");
    const versionParam = searchParams.get("version");

    const {
        data: models_unfiltered,
        isLoading: modelosIsLoading,
        isFetching: modelosIsFetching,
        isSuccess: modelosIsSuccess,
        isError: modelosIsError,
    } = useGetAllModelsQuery();

    // this is to filter the products that dont have any stock
    let models = models_unfiltered?.filter((model) => model.stock > 0);

    const {
        data: accessories,
        isLoading: accessoriesIsLoading,
        isFetching: accessoriesIsFetching,
        isSuccess: accessoriesIsSuccess,
        isError: accessoriesIsError,
    } = useGetAllAccesoriesQuery();

    const {
        data: maintenancePlans,
        isLoading: maintenancePlansIsLoading,
        isFetching: maintenancePlansIsFetching,
        isSuccess: maintenancePlansIsSuccess,
        isError: maintenancePlansIsError,
    } = useGetAllMaintenancePlansQuery();

    const {
        data: legals,
        isLoading: legalsIsLoading,
        isFetching: legalsIsFetching,
        isSuccess: legalsIsSuccess,
        isError: legalsIsError,
    } = useGetLegalesQuery();

    // State
    const [selectedType, setSelectedType] = useState(segmentParam || "all");
    const [selectedModel, setSelectedModel] = useState(serieParam || "all");
    const [selectedVersion, setSelectedVersion] = useState(
        versionParam || "all"
    );
    const [selectedColor, setSelectedColor] = useState("");
    const [showAccessories, setShowAccessories] = useState(false);
    const [showMaintenance, setShowMaintenance] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio",
            },
            {
                link: location.pathname,
                label: location.pathname.slice(1),
            },
        ],
    };

    const TitleAndButtonProps = {
        title: "Conoce todos <br> los modelos disponibles",
        buttons: [
            // {
            //     config: {
            //         tag: "button",
            //         text: "Encuentra tu Lexus",
            //         color: "black",
            //         size: "small"
            //     },
            // }
        ],
        backgroundColor: "white",
        extraClass: "",
    };

    // Filters
    const filterByType = (type, items) => {
        // console.log(`filterByType ${type}`)
        if (type === "all") {
            return items;
        } else {
            const itemsFilteredByType = items.filter(
                (item) => item.segment === type
            );
            return itemsFilteredByType;
        }
    };

    const filterByModel = (model, items) => {
        // console.log(`filterByType ${type}`)
        if (model === "all") {
            return items;
        } else {
            const itemsFilteredByModel = items.filter(
                (item) => item.serie === model
            );
            return itemsFilteredByModel;
        }
    };

    const filterByVersion = (version, items) => {
        // console.log(`filterByType ${type}`)
        if (version === "all") {
            return items;
        } else {
            const itemsFilteredByModel = items.filter(
                (item) => item.version.name === version
            );
            return itemsFilteredByModel;
        }
    };

    const filterByColor = (color, items) => {
        if (color === "") {
            return items;
        } else {
            const itemsFilteredByColor = items.filter(
                (item) => item.color.name === color
            );
            return itemsFilteredByColor;
        }
    };

    // Set the selected type to the value of the input. Ej: suv
    const typeChangeHandler = (e) => {
        const type = e.target.value;

        setSelectedType(type);

        // Reset selected model
        setSelectedModel(() => "all");

        // Reset selected version
        setSelectedVersion(() => "all");

        // Reset selected version
        setSelectedColor(() => "");

        // // Reset toggle mantenciones
        // setShowManteciones(() => false)

        // // Reset toggle accesorios
        // setShowAccesories(() => false)

        // Update URL
        const newParams = new URLSearchParams(searchParams);
        if (type && type !== "all") {
            newParams.set("segment", type);
        } else {
            newParams.delete("segment");
        }
        newParams.delete("serie");
        newParams.delete("version");
        setSearchParams(newParams);
    };

    // Set the selected model or serie to the value of the input. Ej: UX
    const modelChangeHandler = (e) => {
        const model = e.target.value;
        setSelectedModel(model);

        // Reset selected version
        setSelectedVersion(() => "all");

        // // Reset toggle mantenciones
        // setShowManteciones(() => false)

        // // Reset toggle accesorios
        // setShowAccesories(() => false)

        // Update URL
        const newParams = new URLSearchParams(searchParams);
        if (model && model !== "all") {
            newParams.set("serie", model);
        } else {
            newParams.delete("serie");
        }
        newParams.delete("version");
        setSearchParams(newParams);
    };

    // Set the selected version to the value of the input. Ej: UX200
    const versionChangeHandler = (e) => {
        const version = e.target.value;

        setSelectedVersion(version);

        // // Reset toggle mantenciones
        // setShowManteciones(() => false)

        // // Reset toggle accesorios
        // setShowAccesories(() => false)

        // Update URL
        const newParams = new URLSearchParams(searchParams);
        if (version && version !== "all") {
            newParams.set("version", version);
        } else {
            newParams.delete("version");
        }
        setSearchParams(newParams);
    };

    const colorClickHandler = (e) => {
        // console.log("colorClickHandler");

        // // Reset toggle mantenciones
        // setShowManteciones(() => false)

        // // Reset toggle accesorios
        // setShowAccesories(() => false)

        if (selectedColor === e.target.value) {
            setSelectedColor(() => "");
        } else {
            setSelectedColor(() => e.target.value);
        }
    };

    const maintenanceHandler = (e) => {
        setShowMaintenance(!showMaintenance);
    };

    const accesoriesHandler = (e) => {
        setShowAccessories(!showAccessories);
    };

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const data = {
        image: "",
        title: "¿Qué modelo estás buscando?",
        filters: {
            type: {
                title: "Tipo",
                options: [
                    {
                        type: "radio",
                        id: "type-all",
                        label: "Todos",
                        name: "type-all",
                        value: "all",
                        isRequired: false,
                    },
                ],
            },
            model: {
                title: "Serie",
                options: [
                    {
                        type: "radio",
                        id: "model-all",
                        label: "Todos",
                        name: "model-all",
                        value: "all",
                        isRequired: false,
                    },
                ],
            },
            version: {
                title: "Versión",
                options: [
                    {
                        type: "radio",
                        id: "version-all",
                        label: "Todas",
                        name: "version-all",
                        value: "all",
                        isRequired: false,
                    },
                ],
            },
            color: {
                title: "Color Exterior",
            },
            toggle: {
                title: "",
                options: [
                    {
                        type: "toggle",
                        id: "mantenciones-available",
                        label: "Ver Mantenciones disponibles",
                        name: "mantenciones-available",
                        value: "mantenciones-available",
                        isRequired: false,
                        changed: maintenanceHandler,
                        isChecked: showMaintenance === true,
                        extraClass: "--drawer",
                    },
                    {
                        type: "toggle",
                        id: "accesories-available",
                        label: "Ver accesorios disponibles",
                        name: "accesories-available",
                        value: "accesories-available",
                        isRequired: false,
                        changed: accesoriesHandler,
                        isChecked: showAccessories === true,
                        extraClass: "--drawer",
                    },
                ],
            },
        },
    };

    // Items filtered
    let filteredItems;

    // Type list
    let typeList;

    // Model List
    let modelList;

    // Version list
    let versionList;

    // Color list
    let colorList;

    /**
     * addMaintenanceAvailable function
     * @param {Items[]} items
     * @param {maintenancePlans[]} maintenancePlans
     * @returns {maintenances[]}
     */

    const addMaintenancesAvailable = (items, maintenancePlans) => {
        let maintenances = new Set([]);

        for (const item of items) {
            for (const maintenancePlan of maintenancePlans) {
                if (item.version.id === maintenancePlan.version.id) {
                    maintenances.add(maintenancePlan);
                }
            }
        }

        return [...maintenances];
    };

    /**
     * addAccessoriesAvailable function
     * @param {Items[]} items
     * @param {Accessory[]} accessories
     * @returns {accessories[]}
     */

    const addAccessoriesAvailable = (vehicles, accessoriesItems) => {
        const vehiclesVersionsIds = uniqueVersionsIds(vehicles);

        const uniqueAccessoriesMap = new Map([]);
        // const accesoriesArray = []

        for (const accessory of accessoriesItems) {
            // console.log("accesorio", accessory);
            for (const version of accessory.versions) {
                if (vehiclesVersionsIds.includes(version.id)) {
                    // console.log("match", version)
                    uniqueAccessoriesMap.set(accessory.id, accessory);
                }
            }
        }

        // console.log(accesoriesArray)
        // console.log([...uniqueAccessoriesMap.values()])
        return [...uniqueAccessoriesMap.values()];
    };

    if (modelosIsSuccess && maintenancePlansIsSuccess && accessoriesIsSuccess) {
        filteredItems = filterByType(selectedType, models);
        filteredItems = filterByModel(selectedModel, filteredItems);
        filteredItems = filterByVersion(selectedVersion, filteredItems);
        filteredItems = filterByColor(selectedColor, filteredItems);

        filteredItems = showMaintenance
            ? filteredItems.concat(
                  addMaintenancesAvailable(filteredItems, maintenancePlans)
              )
            : filteredItems;
        filteredItems = showAccessories
            ? filteredItems.concat(
                  addAccessoriesAvailable(filteredItems, accessories)
              )
            : filteredItems;

        typeList = uniqueTypes(models);
        modelList = uniqueModels(selectedType, models);
        versionList = uniqueVersions(selectedModel, models);

        colorList = uniqueColors(
            filterByVersion(
                selectedVersion,
                filterByModel(selectedModel, filterByType(selectedType, models))
            )
        );
    }

    const typeInputList = data.filters.type.options.map((option, i) => {
        return (
            <InputRadio
                {...option}
                key={i}
                isChecked={selectedType === option.value}
                changed={typeChangeHandler}
            />
        );
    });

    const typeOptionsList = typeList?.map((item, i) => {
        return (
            <InputRadio
                type="radio"
                id={`type-${item}`}
                label={item.toUpperCase()}
                name={`type-${item}`}
                value={item}
                isRequired={false}
                key={i}
                isChecked={selectedType === item}
                changed={typeChangeHandler}
            />
        );
    });

    const modelInputList = data.filters.model.options.map((option, i) => {
        return (
            <InputRadio
                {...option}
                key={i}
                isChecked={selectedModel === option.value}
                changed={modelChangeHandler}
            />
        );
    });

    const modelOptionsList = modelList?.map((item, i) => {
        return (
            <InputRadio
                type="radio"
                id={`model-${item}`}
                label={item.toUpperCase()}
                name={`model-${item}`}
                value={item}
                isRequired={false}
                key={i}
                isChecked={selectedModel === item}
                changed={modelChangeHandler}
            />
        );
    });

    const versionInputList = data.filters.version.options.map((option, i) => {
        return (
            <InputRadio
                {...option}
                key={i}
                changed={versionChangeHandler}
                isChecked={selectedVersion === option.value}
            />
        );
    });

    const versionOptionList = versionList?.map((item, i) => {
        return (
            <InputRadio
                type="radio"
                id={`version-${item}`}
                label={item.toUpperCase()}
                name={`version-${item}`}
                value={item}
                isRequired={false}
                key={i}
                changed={versionChangeHandler}
                isChecked={selectedVersion === item}
            />
        );
    });

    const colorInputList = colorList?.map((option, i) => {
        const styles = {
            background: `radial-gradient(
                    61.11% 61.11% at 50% 27.78%,
                    ${lightColor(option.hexcode, 25)} 0%,
                    ${option.hexcode} 100%
                )`,
        };

        return (
            <InputRadio
                type="color"
                color={option.name}
                id={`color-${option.name}`}
                label={option.name}
                name={`color-${option.name}`}
                value={option.name}
                isRequired={false}
                key={i}
                changed={() => console.log("color changed")}
                isChecked={selectedColor === option.name}
                clicked={colorClickHandler}
                styles={styles}
            />
        );
    });

    const toggleList = data.filters.toggle.options.map((option, i) => {
        return <InputCheckBox {...option} key={i} />;
    });

    const drawerFilters = [
        {
            label: "Tipo",
            content: (
                <div>
                    {typeInputList}

                    {typeList && typeOptionsList}
                </div>
            ),
        },
        {
            label: "Modelo",
            content: (
                <div>
                    {modelInputList}

                    {modelList && modelOptionsList}
                </div>
            ),
        },
        {
            label: "Versión",

            content: (
                <div>
                    {versionInputList}

                    {versionList && versionOptionList}
                </div>
            ),
        },
        {
            label: "Color Exterior",

            content: <div className="color-container">{colorInputList}</div>,
        },
    ];

    const drawerContent = (
        <>
            <Accordion items={drawerFilters} type={"filters"} />
            {toggleList}
        </>
    );

    return (
        <>
            {modelosIsLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}

            {modelosIsSuccess &&
                maintenancePlansIsSuccess &&
                accessoriesIsSuccess && (
                    <>
                        <Breadcrumbs {...BreadcrumbsProps} />

                        <TitleAndButton {...TitleAndButtonProps} />
                        <StoreGridContainer>
                            <FiltersContainer>
                                <h3>{data.title}</h3>

                                <form action="">
                                    {/* Type, model and version */}
                                    <fieldset className="fieldset-1">
                                        {/* Type */}
                                        <FilterContainer
                                            title={data.filters.type.title}
                                        >
                                            {typeInputList}

                                            {typeList && typeOptionsList}
                                        </FilterContainer>

                                        {/* Model */}
                                        <FilterContainer
                                            title={data.filters.model.title}
                                        >
                                            {modelInputList}

                                            {modelList && modelOptionsList}
                                        </FilterContainer>

                                        {/* Version */}
                                        <FilterContainer
                                            title={data.filters.version.title}
                                        >
                                            {versionInputList}

                                            {versionList && versionOptionList}
                                        </FilterContainer>
                                    </fieldset>

                                    {/* Colors */}
                                    <fieldset className="fieldset-2">
                                        <FilterContainer
                                            title={data.filters.color.title}
                                        >
                                            {colorInputList}
                                        </FilterContainer>
                                    </fieldset>

                                    {/* Toggle */}
                                    <fieldset className="fieldset-3">
                                        <FilterContainer
                                            title={data.filters.type.toggle}
                                        >
                                            {toggleList}
                                        </FilterContainer>
                                    </fieldset>
                                </form>
                            </FiltersContainer>

                            <Button
                                tag="link"
                                text="Filtrar por"
                                hasIcon={"true"}
                                onClick={toggleDrawer}
                            />

                            <BoxWithBackgroundContainer
                                items={filteredItems}
                                extraClass="--store-version"
                            />

                            <Drawer
                                title={"¿Qué modelo estás buscando?"}
                                content={drawerContent}
                                isOpen={isDrawerOpen}
                                close={toggleDrawer}
                            />
                        </StoreGridContainer>
                    </>
                )}

            {modelosIsError && <p>Hubo un error</p>}

            {legalsIsSuccess && <LegalFooter content={legals.models} />}
        </>
    );
};

export default ModelosPage;
